export default {
  type: 'catalog_order',
  aliases: ['demande'],
  slices: [{
    name: 'catalog_form',
    path: 'CatalogOrder/FormCatalog.vue'
  }]
};